"use client";

import { patchReactDOM } from "@stadium/helpers/dom";

const ClientPolyfills = () => {
    patchReactDOM();
    return null;
};

export default ClientPolyfills;